import { IDocStatus } from "src/@types/venue";

export const docStatus: IDocStatus[] = [
  { code: 0, label: 'declined', color: 'error'},
  { code: 1, label: 'pending', color: 'default'},
  { code: 2, label: 'sent', color: 'info'},
  { code: 3, label: 'analyzing', color: 'warning'},
  { code: 4, label: 'approved', color: 'success'},
];